import React, { useState, useEffect } from "react";
import { Marker, Popup } from "react-leaflet";

const POPUPS = [
  { id: 1, label: "Temperature", title: "Temperature",  img: "/map/11410301/temp.png" },
  { id: 2, label: "Pressure",    title: "Pressure",     img: "/map/11410301/pressure.png" },
  { id: 3, label: "Water Level", title: "Water Level",  img: "/map/11410301/water-level.png" },
  { id: 4, label: "Water Elev.", title: "Water Elevation", img: "/map/11410301/water-elevation.png" },
];

function getPos(i) {
  const col = i % 2;              // 0 or 1
  const row = Math.floor(i / 2);  // 0,1
  return {
    top: 40 + row * 130,
    left: 10 + col * 130,
  };
}

function InnerCard({ open, onClose, pos, children }) {
  if (!open) return null;
  return (
    <div
      style={{
        position: "absolute",
        width: 500,
        background: "white",
        border: "1px solid #ddd",
        borderRadius: 8,
        boxShadow: "0 6px 16px rgba(0,0,0,0.2)",
        padding: 10,
        zIndex: 9999,
      }}
    >
      <button
        onClick={onClose}
        aria-label="Close"
        style={{
          position: "absolute",
          top: 6,
          right: 8,
          background: "transparent",
          border: "none",
          fontSize: 16,
          fontWeight: "bold",
          cursor: "pointer",
          color: "#666",
          lineHeight: 1,
        }}
      >
        ×
      </button>
      {children}
    </div>
  );
}

export default function S11410231() {
  // only one open at a time (null = none)
  const [openId, setOpenId] = useState(null);

  const toggle = (id) => setOpenId((prev) => (prev === id ? null : id));
  const closeAll = () => setOpenId(null);

  // ESC to close all
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && closeAll();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <Marker position={[78.869049, 17.682955]}>
      <Popup autoClose={false} closeOnClick={false} maxWidth={340}>
        <div style={{ width: 300, position: "relative" }}>
          <h4 style={{ margin: "0 0 6px 0" }}>Temperature and Pressure Wells in Kaffiøyra</h4>
            <a href='/storage/data/11410231.tar.gz' target="_blank">
                      
                            Download
                       
                          </a>

          {/* trigger links */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: 6,
              marginTop: 10,
            }}
          >
            {POPUPS.map((p) => {
              const isOpen = openId === p.id;
              return (
                <a
                  key={`btn-${p.id}`}
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggle(p.id); // open this, close others
                  }}
                  style={{
                    display: "block",
                    textAlign: "center",
                    textDecoration: "none",
                    border: "1px solid #ddd",
                    borderRadius: 6,
                    padding: "6px 8px",
                    color: isOpen ? "#0a58ca" : "#0d6efd",
                    background: isOpen ? "#eef5ff" : "white",
                  }}
                >
                  {p.label}
                </a>
              );
            })}
          </div>

          {/* inner popups (only one will render at once) */}
          {POPUPS.map((p, i) => {
            const pos = getPos(i);
            const open = openId === p.id;
            return (
              <InnerCard
                key={`card-${p.id}`}
                open={open}
                onClose={() => toggle(p.id)}
                pos={pos}
              >
                <h4 style={{ marginTop: 0, marginBottom: 6 }}>{p.title}</h4>
                <img src={p.img} style={{ width: "100%", borderRadius: 6 }} />
              </InnerCard>
            );
          })}
        </div>
      </Popup>
    </Marker>
  );
}
